<mat-spinner *ngIf="loading" class="connexion-loading"></mat-spinner>
<div class="centralised">
  <h1>Vous n'êtes pas connecté.</h1>
  <br>
  <p>
    {{messageError || 'Veuillez cliquer sur le bouton Se connecter.' }}
  </p>
</div>
